import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import DatasetNamespaceService from '../service';
import actions from '../constants';
import {
  fetchDatasetNamespacesError,
  fetchDatasetNamespacesSuccess,
  updateDatasetNamespacesError,
  addDatasetNamespaceSuccess, removeDatasetNamespaceSuccess,
} from '../actions';

export function* create({
  category,
  code,
  name,
  namespace,
}) {
  const { response, error } = yield call(callAdapter, DatasetNamespaceService.create(code, namespace.trim()));

  if (error) {
    yield put(updateDatasetNamespacesError(category, code, name, error));
  } else {
    yield put(addDatasetNamespaceSuccess(category, code, name, response));
  }
}

export function* destroy({
  category,
  code,
  name,
  namespace,
}) {
  const { error } = yield call(callAdapter, DatasetNamespaceService.destroy(code, namespace));

  if (error) {
    yield put(updateDatasetNamespacesError(category, code, name, error));
  } else {
    yield put(removeDatasetNamespaceSuccess(category, code, name, namespace));
  }
}

export function* namespaces({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasetNamespaceService.namespaces(code));
  if (error) {
    yield put(fetchDatasetNamespacesError(category, code, error));
  } else {
    yield put(fetchDatasetNamespacesSuccess(category, code, response.items));
  }
}

export default function* datasetSNamespacesApi() {
  yield takeEvery(actions.ADD_DATASET_NAMESPACE, create);
  yield takeEvery(actions.REMOVE_DATASET_NAMESPACE, destroy);
  yield takeEvery(actions.FETCH_DATASET_NAMESPACES, namespaces);
}
